import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const { t } = useI18n();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-habana-ink text-habana-cream">
                <div className="font-script text-2xl text-gold">{t("loading")}</div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
}
